export type BusSearchResult = {
	cl: number;
	lc: boolean;
	lt: string;
	sl: number;
	tl: number;
	tp: string;
	ts: string;
	cd: string;
	ct: number;
};

export default async function searchBusDir(searchTerm: string, dir: number) {
	const response = await fetch(
		encodeURI(
			'/api-proxy/data/Linha/BuscarLinhaSentido' +
				`?termosBusca=${searchTerm}&sentido=${dir}`,
		),
		{ headers: { 'Content-Type': 'application/json' } },
	);
	if (!response.ok) return [];

	const data = (await response.json()) as BusSearchResult[];
    
	return data;
}
